export const memberRoutesViewLoaders = {
  memberAccount: () => {
    return import(/* webpackChunkName: "member-account-view" */ 'app/scripts/views/member/member-account-view.coffee').then(
      (m) => m.default,
    );
  },
  memberBilling: () => {
    return import(/* webpackChunkName: "member-billing-view" */ 'app/scripts/views/member/member-billing-view.coffee').then(
      (m) => m.default,
    );
  },
  memberCards: () => {
    return import(/* webpackChunkName: "member-cards-view" */ 'app/scripts/views/member/member-cards-view.coffee').then(
      (m) => m.default,
    );
  },
  memberProfile: () => {
    return import(/* webpackChunkName: "member-profile-view" */ 'app/scripts/views/member-home-profile-tab').then(
      (m) => m.MemberHomeProfileTab,
    );
  },
  memberActivity: () => {
    return import(/* webpackChunkName: "member-activity-view" */ 'app/scripts/views/member/member-activity-view.coffee').then(
      (m) => m.default,
    );
  },
};
